<template>
  <div
    id="settingsWishlistModal"
    :class="['wish-modal', { show: !loading }]"
    tabindex="-1"
    aria-labelledby="settingsWishlistLabel"
    role="dialog"
    aria-modal="true"
    @click="closeModal"
  >
    <section @click="stopPropagation($event)" v-if="!showDeleteWishlist">
      <button
        type="button"
        class="btn fs-7"
        aria-label="Close"
        @click="closeModal"
      >
        <span class="icon-close"></span>
      </button>
      <h2 id="settingsWishlistLabel">Indstillinger</h2>
      <div class="input-wrapper">
        <label for="wishlistName">Ønskelistens navn</label>
        <input
          id="wishlistName"
          type="text"
          placeholder="Min ønskeliste"
          v-model="wishlistName"
        />
        <span></span>
      </div>
      <div class="error-info" role="alert" v-if="hasError">
        {{ errorMessage }}
      </div>
      <div v-else>Højst 50 tegn</div>
      <div class="w-100 flex-row-reverse">
        <div class="d-flex flex-row-reverse">
          <button
            type="button"
            class="btn border rounded-pill"
            @click="updateWishlist"
          >
            Gem
          </button>
          <button type="button" class="btn me-3" @click="closeModal">
            Annullér
          </button>
        </div>
        <button
          type="button"
          class="btn border rounded-pill"
          @click="showDeleteWishlistModul"
        >
          Slet
        </button>
      </div>
    </section>
    <section v-else>
      <button
        type="button"
        class="btn fs-7"
        aria-label="Close"
        @click="hideDeleteWishlistModul"
      >
        <span class="icon-close"></span>
      </button>
      <h2 id="settingsWishlistLabel">Slet denne ønskeliste</h2>
      <div class="justify-content-around">
        <button type="button" class="btn" @click="hideDeleteWishlistModul">
          Annullér
        </button>
        <button
          type="button"
          class="btn btn-orange rounded-pill"
          @click="deleteWishlist"
        >
          Ja, slet
        </button>
      </div>
    </section>
  </div>
</template>
<script>
import helpers from "../../plugins/globalHelpers.js";
export default {
  name: "SettingsWishlistModal",
  props: ["wishlist"],
  data() {
    return {
      loading: true,
      wishlistName: "",
      hasError: false,
      errorMessage: "Ønskelistens navn skal udfyldes",
      showDeleteWishlist: false,
    };
  },
  mounted() {
    this.init();
    helpers.trapFocus(document.getElementById("settingsWishlistModal"));
  },
  methods: {
    init: function () {
      this.wishlistName = this.wishlist.name;
      document.body.style.paddingRight = "8px";
      document.body.style.overflow = "hidden";
      document.body.classList.add("modal-open");
      setTimeout(() => {
        this.loading = false;
      }, 0);
    },
    closeModal: function () {
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
      document.body.classList.remove("modal-open");
      this.loading = true;
      setTimeout(() => {
        this.$parent.hideSettings();
      }, 300);
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    updateWishlist: function () {
      if(this.wishlistName.length && this.wishlistName.length <= 50) {
        this.hasError = false;
        const params = { listId: this.wishlist.id, name: this.wishlistName };
        this.$store.dispatch("updateWishlist", params).then((response) => {
          this.$store.dispatch("getWishlists");
          this.$parent.init();
          this.closeModal();
        });
      } else if(this.wishlistName.length > 50) {
          this.errorMessage = "Listens navn må højst være 50 tegn";
          this.hasError = true;
      } else {
        this.errorMessage = "Ønskelistens navn skal udfyldes";
        this.hasError = true;
      }
    },
    deleteWishlist: function () {
      const wishlistName = this.wishlist.name;
      this.$store
        .dispatch("deleteWishlist", this.wishlist.id)
        .then((response) => {
          // If success
          this.$store.dispatch("getWishlists");
          this.$parent.wishlistDeleted(wishlistName);
        });
    },
    showDeleteWishlistModul: function () {
      this.showDeleteWishlist = true;
    },
    hideDeleteWishlistModul: function () {
      this.showDeleteWishlist = false;
    },
  },
};
</script>